/**
 * Securly suite apps for the header App Switcher.
 * Order matches the Securly Design System (Filter → MDM).
 * The current product (`CURRENT_APP_ID`) is filtered out at render time.
 *
 * Icons are product marks from the Securly Design System (Figma).
 *
 * Login URL naming by product family:
 * - Securly web (Filter / Aware / Home): rtqawww on development & staging,
 *   www on production-like envs.
 * - Pass & Flex (same pattern):
 *   development → https://dev-content.{product}.securly.com/login
 *   staging     → https://sta-content.{product}.securly.com/login
 *   production  → https://{product}.securly.com/login
 * - Others (Classroom, MDM, Reveal, AI Chat): production host only
 *   (no rtqa / env host available).
 */
export const CURRENT_APP_ID = "pass"

const iconPath = (name) => `/img/app-switcher/${name}.svg`

const env = import.meta.env.VITE_DD_ENV
const isDevOrStaging = env === "development" || env === "staging"

const SECURLY_WEB_ORIGIN = isDevOrStaging
  ? "https://rtqawww.securly.com"
  : "https://www.securly.com"

/** Resolve a path on the Securly web/login host for the current env. */
export const securlyWebLoginUrl = (path) =>
  `${SECURLY_WEB_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`

/**
 * Pass and Flex share host naming:
 *   {dev-content|sta-content|}.pass.securly.com
 *   {dev-content|sta-content|}.flex.securly.com
 */
export const passFlexLoginUrl = (product) => {
  const prefix =
    env === "development"
      ? "dev-content."
      : env === "staging"
        ? "sta-content."
        : ""
  return `https://${prefix}${product}.securly.com/login`
}

export const SECURLY_APPS = [
  {
    id: "filter",
    name: "Filter",
    iconSrc: iconPath("filter"),
    loginUrl: securlyWebLoginUrl("/app/filter")
  },
  {
    id: "ai-transparency",
    name: "AI Transparency",
    iconSrc: iconPath("ai-transparency"),
    loginUrl: "https://chat.securly.com"
  },
  {
    id: "aware",
    name: "Aware",
    iconSrc: iconPath("aware"),
    loginUrl: securlyWebLoginUrl("/app/login?product=aware")
  },
  {
    id: "classroom",
    name: "Classroom",
    iconSrc: iconPath("classroom"),
    loginUrl: "https://deviceconsole.securly.com/classroom"
  },
  {
    id: "pass",
    name: "Pass",
    iconSrc: iconPath("pass"),
    loginUrl: passFlexLoginUrl("pass")
  },
  {
    id: "flex",
    name: "Flex",
    iconSrc: iconPath("flex"),
    loginUrl: passFlexLoginUrl("flex")
  },
  {
    id: "home",
    name: "Home",
    iconSrc: iconPath("home"),
    loginUrl: securlyWebLoginUrl("/app/home")
  },
  {
    id: "reveal",
    name: "Reveal",
    iconSrc: iconPath("reveal"),
    loginUrl: "https://dyknow.me"
  },
  {
    id: "mdm",
    name: "MDM",
    iconSrc: iconPath("mdm"),
    loginUrl: "https://deviceconsole.securly.com/mdm"
  }
]

export const getSwitchableApps = (currentAppId = CURRENT_APP_ID) =>
  SECURLY_APPS.filter((app) => app.id !== currentAppId)
